import { Box, Stack, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

import { TopicsScores } from '@/domain/impact-calculate/entities/calculate.entity';
import { ScoreTag } from '@/ui/components/score/ScoreTag';
import { language } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

import { VenueDateCalendar } from './VenueDateCalendar';

export function VenueMonthCard({
  month,
  selectedDays,
  scores,
  onClickDate,
}: {
  month: Dayjs;
  selectedDays: Dayjs[];
  scores: TopicsScores;
  onClickDate: (date: Dayjs) => void;
}) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: ColorsRaw.anthracite.Anthracite_4,
        borderRadius: '0.5rem',
        p: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.875rem',
          fontWeight: 800,
          textTransform: 'capitalize',
        }}
      >
        {dayjs(month).locale(language).format('MMMM')}
      </Typography>
      <VenueDateCalendar
        month={month}
        selectedDays={selectedDays}
        onClickDate={onClickDate}
      />
      <Stack sx={{ flexDirection: 'row', gap: 2, mt: 1 }}>
        <ScoreTag
          value={scores.co2}
          colors={getColorForScore(scores.co2)}
          topic="co2"
          orientation="vertical"
        />
        <ScoreTag
          value={scores.env}
          colors={getColorForScore(scores.env)}
          topic="env"
          orientation="vertical"
        />
        <ScoreTag
          value={scores.ess}
          colors={getColorForScore(scores.ess)}
          topic="ess"
          orientation="vertical"
        />
      </Stack>
    </Box>
  );
}
